import { useQuery } from '@apollo/client';
import { PROGRAMS } from '@src/graphql/queries/program';
import { useAuth } from '@src/hooks/useAuth';
import { ProgramStatus } from '@src/types';
import { useCallback, useMemo } from 'react';
export const usePrograms = ({ employeeId, isCurrentUser = true, statuses, excludeSingleExpenses = true, orderBy, orderByDir, } = {}) => {
    const { currentUser } = useAuth();
    const empId = (isCurrentUser && currentUser?.employeeId) || employeeId;
    const shouldSkip = !currentUser || !empId;
    const { data, error, loading } = useQuery(PROGRAMS, {
        variables: {
            spec: {
                employeeId: empId,
                statuses,
                excludeSingleExpenses,
                orderBy,
                orderByDir,
            },
        },
        skip: shouldSkip,
    });
    const programs = useMemo(() => (data?.programs || []), [data?.programs]);
    const find = useCallback((id) => programs.find(program => program.id === id), [programs]);
    const activePrograms = useMemo(() => programs.filter(program => program.status === ProgramStatus.ACTIVE), [programs]);
    const newRequestUrl = useMemo(() => {
        return activePrograms.length > 0 ? '/requests' : '/programs/new';
    }, [activePrograms]);
    return {
        programs,
        activePrograms,
        error,
        loading,
        find,
        newRequestUrl,
    };
};
